/**
 * pbf-mail.js — zet versleutelde e-mailadressen terug (zie snippets/pbf-mail.liquid).
 *
 * In de HTML staat een adres omgekeerd, met "/" in plaats van "@", zodat
 * spambots het niet als e-mailadres herkennen. Dit script maakt er in de
 * browser weer een gewoon, klikbaar adres van:
 *   - .pbf-mail[data-pbf-mail]  → het adres als tekst (of als link, als het nog niet in een link staat)
 *   - a[href*="#pbf-mail="]     → href wordt mailto:adres
 *
 * Een MutationObserver vangt inhoud op die later wordt ingeladen, zoals
 * secties die de thema-editor of de variantkeuze opnieuw rendert.
 */
(function () {
  var LINK = 'a[href*="#pbf-mail="]';
  var TEKST = '.pbf-mail[data-pbf-mail]';

  function ontcijfer(code) {
    return code.split('').reverse().join('').replace('/', '@');
  }

  function herstel(root) {
    if (!root || !root.querySelectorAll) return;

    var links = Array.prototype.slice.call(root.querySelectorAll(LINK));
    if (root.matches && root.matches(LINK)) links.unshift(root);
    links.forEach(function (a) {
      var code = a.getAttribute('href').split('#pbf-mail=')[1];
      if (code) a.setAttribute('href', 'mailto:' + ontcijfer(decodeURIComponent(code)));
    });

    var teksten = Array.prototype.slice.call(root.querySelectorAll(TEKST));
    if (root.matches && root.matches(TEKST)) teksten.unshift(root);
    teksten.forEach(function (el) {
      var adres = ontcijfer(el.getAttribute('data-pbf-mail'));
      var nieuw;
      if (el.closest('a')) {
        nieuw = document.createTextNode(adres);
      } else {
        nieuw = document.createElement('a');
        nieuw.href = 'mailto:' + adres;
        nieuw.textContent = adres;
      }
      el.parentNode.replaceChild(nieuw, el);
    });
  }

  function start() {
    herstel(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (mutaties) {
      mutaties.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType === 1) herstel(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
